<div class="supplementary-equipment no-field-space">
  <sc-master-detail [selection]="[selectedEquipment]" [data]="euqipment" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <sc-padding>

        <sc-tab-group>
          <sc-tab
            titleDictionaryKey="tmc-common.ui.supplementary-equipment.base-data">

            <ng-container *ngIf="workingCopyDetails">

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
                [labelDictionaryKey]="'tmc.admin.supplementary-equipment.name'" [required]="true" [maxlength]="255">
              </sc-dictionary-field>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <mat-checkbox class="form-checkbox" [(ngModel)]="workingCopyDetails.singleUse">
                {{'singleUse' | translate: ['tmc.admin.supplementary-equipment.singleUse',
                translationService.language]}}
              </mat-checkbox>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    {{'parameter1 type' | translate: ['tmc.admin.supplementary-equipment.parameter1.type',
                    translationService.language]}}
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter1Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      {{o.name | translate: ['tmc.admin.supplementary-equipment.parameterType.' + o.name,
                      translationService.language]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter1" [defaultLabel]="'parameter 1 name'"
                  [labelDictionaryKey]="'tmc.admin.supplementary-equipment.parameter1.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    {{'parameter2 type' | translate: ['tmc.admin.supplementary-equipment.parameter2.type',
                    translationService.language]}}
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter2Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      {{o.name | translate: ['tmc.admin.supplementary-equipment.parameterType.' + o.name,
                      translationService.language]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter2" [defaultLabel]="'parameter 2 name'"
                  [labelDictionaryKey]="'tmc.admin.supplementary-equipment.parameter2.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    {{'parameter3 type' | translate: ['tmc.admin.supplementary-equipment.parameter3.type',
                    translationService.language]}}
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter3Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      {{o.name | translate: ['tmc.admin.supplementary-equipment.parameterType.' + o.name,
                      translationService.language]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter3" [defaultLabel]="'parameter 3 name'"
                  [labelDictionaryKey]="'tmc.admin.supplementary-equipment.parameter3.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

            </ng-container>

          </sc-tab>
          <sc-tab
            titleDictionaryKey="tmc-common.ui.supplementary-equipment.identifiers">

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <app-equipment-identifier [selectedDetails]="selectedDetails" (deleteClicked)="deleteIdentifier($event)"
              (changeActiveClicked)="changeActiveOfIdentfier($event)"
              (addNewIdentifierClicked)="addNewIdentifier($event)"></app-equipment-identifier>

          </sc-tab>

        </sc-tab-group>

      </sc-padding>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      <div class="spacer grow"></div>
      <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
        [disabled]="cancelDisabled">{{'cancel' | translate: ['tmc.admin.supplementary-equipment.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button type="button" class="config-changed-button" (click)="save()"
        [disabled]="saveDisabled">{{'save'
        | translate: ['tmc.admin.supplementary-equipment.action.save',
        translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>
</div>
